import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";

import { authContext } from "@/contexts";
import { routesUrlsData } from "@/data";
import { getUserInfo } from "@/redux/actions";

export const AuthProvider = ({ children }) => {
    const dispatch = useDispatch();

    const user = useSelector(({ authReducer }) => authReducer.user);

    const isLoggedOut = useSelector(({ authReducer }) => authReducer.isLoggedOut);

    const loading = useSelector(({ authReducer }) => authReducer.loader);

    const location = useLocation();

    const navigate = useNavigate();

    useEffect(
        () => {
            if (
                isLoggedOut
            && !loading
            && location.pathname !== routesUrlsData.auth.login
            && location.pathname !== routesUrlsData.auth.setPassword
            ) {
                navigate(
                    routesUrlsData.auth.login,
                    {
                        replace: true,
                        state: { from: location },
                    },
                );
            }
        },
        [
            isLoggedOut,
            loading,
            location.pathname,
        ],
    );

    useEffect(
        () => void dispatch(getUserInfo()),
        [],
    );

    return (
        <authContext.Provider value={user}>{children}</authContext.Provider>
    );
};
